<template>
  <div>
    <p v-for="message in group.messages">{{ message.content }}</p>
  </div>
</template>

<script setup lang="ts">
import type { GroupType, MessageGroupContainer } from "~/composables/messages";

defineProps<{
  group: MessageGroupContainer & { type: GroupType.SAMEDAY };
}>();
</script>
